<template>
  <camoodoo-page
    icon="help_outline"
    title="Connecting a Sony Camera with Playmemories support"
  >
    <simple-section light title="General">
      <p>
        Before you start ensure your camera has support for PlayMemories Apps
        and your camera has installed the latest version of the PlayMemories App
        "Smart Remote Control". (see
        <a
          href="https://www.playmemoriescameraapps.com/portal/usbdetail.php?eid=IS9104-NPIA09014_00-F00002"
          >Playmemories Smart Remote Control</a
        >). All cameras are delivered with an embedded Version of this App,
        which is either not compatible or has only very basic functions. Refer
        to your Cameras handbook to see how this can be installed.
      </p>
      <p>
        If your camera does not support PlayMemories Apps then follow the
        instructions on this page:
      </p>
      <p>
        <page-link label="Connecting a Sony camera" route="/help/connectSony" />
      </p>
    </simple-section>
    <simple-section dark title="Prepare the camera">
      <ol>
        <li>Turn on your Sony camera.</li>
        <li>Open the camera menu.</li>
        <li>Select the "Application List" menu item.</li>
        <li>Select "Smart Remote Control".</li>
        <li>Wait until the camera has opened the Wifi network.</li>
      </ol>
    </simple-section>
    <simple-section light title="Connect for the first time with Camoodoo">
      <ol>
        <li>Launch Camoodoo on your smartphone.</li>
        <li>Select "Add new camera".</li>
        <li>Select "Sony".</li>
        <li>Select QR-Code.</li>
        <li>Scan the QR-Code shown on the camera.</li>
      </ol>
      Camoodoo now tries to connect to the camera. If you experience any
      problems, please look into the FAQ.
    </simple-section>
    <simple-section dark title="Reconnect with Camoodoo">
      <ol>
        <li>Turn on your Sony camera.</li>
        <li>Open the camera menu.</li>
        <li>Select the "Application List" menu item.</li>
        <li>Select "Smart Remote Control".</li>
        <li>Wait until the camera has opened the Wifi network.</li>
        <li>Launch Camoodoo on your smartphone.</li>
        <li>Choose the camera.</li>
      </ol>
      Camoodoo now tries to connect to the camera. If you experience any
      problems, please look into the FAQ.
    </simple-section>
    <simple-section light title="Connect for Image Transfer">
      <ol>
        <li>Turn on your Sony camera.</li>
        <li>Open the camera menu.</li>
        <li>Select the "Send to Smartphone" menu item.</li>
        <li>Select "Smart Remote Control".</li>
        <li>Select one of the options</li>
        <li>Wait until the connection screen is shown</li>
        <li>Launch Camoodoo on your smartphone.</li>
        <li>Choose the camera.</li>
      </ol>
      Camoodoo now tries to connect to the camera. If you already selected some
      images on the camera, it will automatically download them. If you
      experience any problems, please look into the FAQ.
    </simple-section>
  </camoodoo-page>
</template>

<script>
import SimpleSection from "@/sections/SimpleSection.vue";
import CamoodooPage from "@/components/CamoodooPage.vue";
import PageLink from "../../components/PageLink.vue";

export default {
  components: {
    SimpleSection,
    CamoodooPage,
    PageLink,
  },
};
</script>

<style lang="scss" scoped></style>
